import React from 'react';

const RadioButton = ({ label, group, value, checked, onChange }) => {
  return (
    <label style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '10px' }}>
      <input
        type="radio"
        name={group}
        value={value}
        checked={checked} 
        onChange={onChange}
        style={{ marginBottom: '5px' }}  
      />
      {label}
    </label>
  );
};

export default RadioButton;
